module.exports = __webpack_public_path__ + "img/envlop-5.e36bd9b7.svg";